<div class="modal-header">
  <h3 class="modal-title">Estimate Mapping
    <i class="fa fa-times pull-right" (click)="cancel()"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px" (click)="minimise=!minimise"></i>
  </h3>
</div>
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <div class="panel panel-default">
    @if (showEntityLoader) {
<div class="panel-body"><i class="fa fa-spinner fa-spin"></i> Loading...</div>
}
    @if (!showEntityLoader) {
<div class="panel-body">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="tax-year"><b>SchDm Template ID<sup>*</sup>:</b></label>
            <select class="form-control" [(ngModel)]="estMapping.SCHDM_TYPE_ID" [disabled]="isEdit === 1">
              <option [ngValue]="null">Select</option>
              @for (x of SchDmTypeList; track $index) {
<option [ngValue]="x.SCHDMID">{{ x.SCHDMID }}</option>
}
            </select>
            @if (validationFlags.SCHDM_TYPE_ID_NOT_VALID && !estMapping.SCHDM_TYPE_ID) {
<small class="text-danger">Please provide SchDm Template ID</small>
}
          </div>
        </div>
        <div class="col-md-4">
          <label for="scenario-type-1"><b>Adjustment Type<sup>*</sup>:</b></label>
          <select class="form-control" [(ngModel)]="estMapping.ADJ_TYPE" [disabled]="isEdit === 1">
            <option [ngValue]="null">Select</option>
            @for (r of adjTypeList; track $index) {
<option [ngValue]="r.CODE_NAME">{{ r.CODE_NAME }}</option>
}
          </select>
          @if (validationFlags.ADJ_TYPE_NOT_VALID && !estMapping.ADJ_TYPE) {
<small class="text-danger">Please provide Adjustment Type</small>
}
        </div>
        <div class="col-md-4">
          <label for="scenario-type-1"><b>Line Details<sup>*</sup>:</b></label>
          <select class="form-control" [(ngModel)]="estMapping.LINE_DETAILS" (ngModelChange)="onLineDetailsChange()">
            <option [ngValue]="null">Select</option>
            @for (t of lineDetailList; track $index) {
<option [ngValue]="t.LINE_DETAIL">{{ t.LINE_DETAIL }}</option>
}
          </select>
          @if (validationFlags.LINE_DETAILS_NOT_VALID && !estMapping.LINE_DETAILS) {
<small class="text-danger">Please provide Line Details</small>
}
        </div>
      </div>
    </div>
}
  </div>
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm save-button" type="button" (click)="estimateMapping(false)">
    Save <span>@if (saveloader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span>
  </button>
  @if (isEdit === 1) {
<button class="btn btn-warning btn-sm" type="button" (click)="estimateMapping(true)">
    Delete <span>@if (saveloader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span>
  </button>
}
  <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
